// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { productPriceAndActionsStyle } from "@vanmeter/App/Components/Product/ProductPriceAndActions";
import { fontConfig, PLP_BREAKPOINT } from "@vanmeter/XDL/constants";
import { color, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

productPriceAndActionsStyle.productGridContainer = {
    container: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            gap: 0;
        `,
    },
    addToList: {
        css: css`
            margin-top: 4px;
            :empty {
                border-top: unset;
            }
        `,
    },
    addToCartActions: {
        css: css`
            ${({ showDivider }: any) =>
                showDivider &&
                css`
                    border-top: 1px solid ${color("common.border")};
                    padding-top: 12px;
                `}
        `,
    },
};
productPriceAndActionsStyle.productListProductImageStyles = {
    wrapper: {
        css: css`
            width: auto;
        `,
    },
};

productPriceAndActionsStyle.productPriceStyles = {
    price: {
        signInText: {
            ...fontConfig.xSmallSingleLine,
            css: css`
                ${StyledButton} > ${TypographyStyle} {
                    font-size: ${fontConfig.xSmallSingleLine.size}px;
                    line-height: ${fontConfig.xSmallSingleLine.lineHeight};
                }
            `,
        },
    },
};

productPriceAndActionsStyle.productActionsStyles = {
    addToCartContainer: {
        css: css`
            ${xScreen("lte", PLP_BREAKPOINT)} {
                flex-wrap: unset;
                gap: unset;
                justify-content: space-between;
                gap: 8px;
            }
        `,
    },
    addToCartButtonWrapper: {
        css: css`
            flex-grow: 1;
        `,
    },
    addToCartFallbackMessage: {
        size: fontConfig.smallSingleLine.size,
        lineHeight: "19px",
    },
};

productPriceAndActionsStyle.qtyNumbersStyles = {
    container: {
        css: css`
            margin: 12px 0;
        `,
    },
    leftSection: {
        css: css`
            gap: 4px;
        `,
    },
};
